import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Procedures from "@/pages/Procedures";
import ProcedureDetail from "@/pages/ProcedureDetail";
import Categories from "@/pages/Categories";
import Packages from "@/pages/Packages";
import Commission from "@/pages/Commission";
import ImageLibrary from "@/pages/ImageLibrary";
import Reports from "@/pages/Reports";
import AuditLogs from "@/pages/AuditLogs";
import Settings from "@/pages/Settings";

const Shell = ({ children }) => (
  <ProtectedRoute><Layout>{children}</Layout></ProtectedRoute>
);

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
      <AuthProvider>
        <Toaster position="bottom-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Shell><Dashboard /></Shell>} />
          <Route path="/procedures" element={<Shell><Procedures /></Shell>} />
          <Route path="/procedures/:id" element={<Shell><ProcedureDetail /></Shell>} />
          <Route path="/categories" element={<Shell><Categories /></Shell>} />
          <Route path="/packages" element={<Shell><Packages /></Shell>} />
          <Route path="/commission" element={<Shell><Commission /></Shell>} />
          <Route path="/images" element={<Shell><ImageLibrary /></Shell>} />
          <Route path="/reports" element={<Shell><Reports /></Shell>} />
          <Route path="/audit" element={<Shell><AuditLogs /></Shell>} />
          <Route path="/settings" element={<Shell><Settings /></Shell>} />
        </Routes>
      </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
